import React from 'react'
import { useAuth } from '../auth.jsx'
import { Button } from '@ui'

export function LoginPage() {
  const { signIn } = useAuth()

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.brand}>
          <img src="/logo-mark.svg" alt="" width={24} height={24} />
          <h1 style={styles.title}>Soundcheck</h1>
        </div>
        <p style={styles.tagline}>Platform administration.</p>
        <Button size="lg" onClick={signIn} style={{ width: '100%' }}>
          Sign in
        </Button>
      </div>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fafaf9',
    backgroundImage: 'url(/login-bg.svg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  card: {
    background: '#ffffff',
    border: '1px solid #e8e8e6',
    borderRadius: '12px',
    padding: '40px',
    width: '360px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  brand: { display: 'flex', alignItems: 'center', gap: '8px' },
  title: { fontSize: '20px', fontWeight: 700, letterSpacing: '-0.02em', color: '#1a1a1a' },
  tagline: { color: '#6b6b6b', fontSize: '12px' },
}
